export default "__VITE_ASSET__B2tt$QhD__"